import { IssueAttachmentService as OvermapIssueAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueAttachmentService extends OvermapIssueAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
